export const groupEditListItemTheme = {
  borderColor: 'palette.tertiary.20',
  borderWidth: '1px',
  text: 'palette.neutral.90',
};
